var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8.2 15.4",
    style: {
      enableBackground: "new 0 0 8.2 15.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D8D8D8;}\r\n\t.st1{fill:#FF5050;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(0 -1.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    transform: "translate(0 1.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "down",
    className: "st0",
    d: "M0,6.4h8.2L4.1,0L0,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "up",
    className: "st1",
    d: "M8.2,9H0l4.1,6.4L8.2,9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/arrow_red.5d4068f8a53eb9b773411e2e02106999.svg";
export { ForwardRef as ReactComponent };